export default {
  LEVEL_OF_EDUCATION_REPOSITORY: Symbol.for('LEVEL_OF_EDUCATION_REPOSITORY'),
  GET_ALL_LEVEL_OF_EDUCATION_QUERY: Symbol.for('GET_ALL_LEVEL_OF_EDUCATION_QUERY'),
  LEVEL_OF_EDUCATION_STATE_MANAGER: Symbol.for('LEVEL_OF_EDUCATION_STATE_MANAGER'),
};
